import api from "@/services/api";
import type {
	ExportResponse,
	GenerateReportRequest,
} from "../types/generate-report-request";

export const dataExportService = {
	exportReport: async (
		payload: GenerateReportRequest
	): Promise<ExportResponse> => {
		const response = await api.post<ExportResponse>("/api/export", payload);
		return response.data;
	},
};
